module.exports = __webpack_public_path__ + "static/banner2-3429ee928a6920d7c806a9e7d4a542d4.png";